import * as React from "react";
import Header from "./Header";
import { LayoutProps } from "./Layout";
import { theme } from "@Definitions/Styled";
import { useRouter } from "next/router";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useCallback, useEffect, useRef } from "react";
import dynamic from "next/dynamic";
const PreFooter = dynamic(() => import("./PreFooter"), { ssr: false });
const Footer = dynamic(() => import("./Footer"), { ssr: false });
const WhatsAppFloating = dynamic(() => import("./WhatsAppFloating"), {
  ssr: false,
});

const Layout: React.FunctionComponent<LayoutProps> = ({
  children,
}): JSX.Element => {
  const router = useRouter();

  const feedRef = useRef(null);

  useEffect(() => {
    if (!feedRef.current || router.pathname !== "/") return;

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadScript();
            observerInstance.unobserve(entry.target); // Only once
          }
        });
      },
      {
        threshold: 0.5, // 50% of feed in viewport
      }
    );

    observer.observe(feedRef.current);

    return () => {
      if (feedRef.current) observer.unobserve(feedRef.current);
    };
  }, [router.pathname]);

  const curatorLoadedRef = useRef(false);

  const loadScript = useCallback(() => {
    if (curatorLoadedRef.current) return;
    const script = document.createElement("script");
    script.src =
      "https://cdn.curator.io/published/13014a2d-73fd-41f9-a276-28d8e6d5c674.js";
    script.defer = true;
    script.async = true;
    document.body.appendChild(script);
    curatorLoadedRef.current = true;
  }, []);

  return (
    <div>
      <Header />
      {children}
      {router.pathname == "/" && <WhatsAppFloating />}

      {router.pathname == "/" ? (
        <Box ref={feedRef} style={{ marginBottom: "2rem" }}>
          {" "}
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "1.5rem",
              color: theme.palette.primary.main,
            }}
          >
            <Icon
              component={InstagramIcon}
              fontSize="large"
              sx={{ marginRight: "0.5rem" }}
            />{" "}
            <Typography variant="h4">@econut.store</Typography>
          </Box>
          <div id="curator-feed-default-feed-layout">
            <a
              href="https://curator.io"
              target="_blank"
              className="crt-logo crt-tag"
              title="curator.io"
            ></a>
          </div>
        </Box>
      ) : (
        ""
      )}
      <PreFooter />
      <Footer />
    </div>
  );
};

export { Layout };
